module.exports = __webpack_public_path__ + "img/12.c2fc6711.png";